import {getAnnouncementsAndNotifications} from "../../vuex/actions"
import store from '../../vuex/store';
import * as actions from '../../vuex/actions';
import toastr from 'toastr';
import DOMPurify from 'dompurify';

function getData() {
  actions.getFolders(store);
  actions.getGroups(store);
  actions.getLabels(store);
  actions.getPresentations(store);
  actions.getUsers(store);
}

/**
 * Listen for messages sent to the current user
 */
function listenForCurrentUser() {
  window.Echo.private(window.ML.user.channel)
    .notification(notification => {
      console.log('Notification received', notification);
      if (notification.message) {
        if ('error' === notification.message_type) {
          toastr.error(DOMPurify.sanitize(notification.message), DOMPurify.sanitize(notification.message_title))
        } else if ('warning' === notification.message_type) {
          toastr.warning(DOMPurify.sanitize(notification.message), DOMPurify.sanitize(notification.message_title));
        } else {
          toastr.success(DOMPurify.sanitize(notification.message), DOMPurify.sanitize(notification.message_title))
        }
      }
      getAnnouncementsAndNotifications(store);
      //sharedLinkService.getSharedLinks();
    });
}

function listenForCurrentTeam() {
  if (window.ML.user.currentTeam) {
    window.Echo.private(window.ML.user.currentTeam.channel)
      .listen('CRM.UserContactsImported', e => { // MLD-2598
        console.log('event CRM.UserContactsImported', e);
        toastr.success(DOMPurify.sanitize(e.message));
      })
      .listen('Models.Folder.Created', e => {
        console.log('event Models.Folder.Created', e);
        getData();
      })
      .listen('Models.Folder.Deleted', e => {
        console.log('event Models.Folder.Deleted', e);
        getData();
      })
      .listen('Models.Folder.Updated', e => {
        console.log('event Models.Folder.Updated', e);
        getData();
      })
      .listen('Models.Group.AddedToPresentation', e => {
        console.log('event Models.Group.AddedToPresentation', e);
        getData();
      })
      .listen('Models.Group.Created', e => {
        console.log('event Models.Group.Created', e);
        getData();
      })
      .listen('Models.Group.Deleted', e => {
        console.log('event Models.Group.Deleted', e);
        getData();
      })
      .listen('Models.Group.RemovedFromPresentation', e => {
        console.log('event Models.Group.RemovedFromPresentation', e);
        getData();
      })
      .listen('Models.Group.Updated', e => {
        console.log('event Models.Group.Updated', e);
        getData();
      })
      .listen('Models.Label.AddedToPresentation', e => {
        console.log('event Models.Label.AddedToPresentation', e);
        getData();
      })
      .listen('Models.Label.Created', e => {
        console.log('event Models.Label.Created', e);
        getData();
      })
      .listen('Models.Label.Deleted', e => {
        console.log('event Models.Label.Deleted', e);
        getData();
      })
      .listen('Models.Label.RemovedFromPresentation', e => {
        console.log('event Models.Label.RemovedFromPresentation', e);
        getData();
      })
      .listen('Models.Label.Updated', e => {
        console.log('event Models.Label.Updated', e);
        getData();
      })
      .listen('Models.Presentation.AddedToFolder', e => {
        console.log('event Models.Presentation.AddedToFolder', e);
        getData();
      })
      .listen('Models.Presentation.Created', e => {
        console.log('event Models.Presentation.Created', e);
        getData();
      })
      .listen('Models.Presentation.Deleting', e => {
        console.log('event Models.Presentation.Deleting', e);
        getData();
      })
      .listen('Models.Presentation.Deleted', e => {
        console.log('event Models.Presentation.Deleted', e);
        getData();
      })
      .listen('Models.Presentation.GeneratingThumbnails', e => {
        console.log('event Models.Presentation.GeneratingThumbnails', e);
        getData();
      })
      .listen('Models.Presentation.GeneratedThumbnails', e => {
        console.log('event Models.Presentation.GeneratedThumbnails', e);
        getData();
      })
      .listen('Models.Presentation.GeneratingThumbnailsFailed', e => {
        console.log('event Models.Presentation.GeneratingThumbnailsFailed', e);
        getData();
      })
      .listen('Models.Presentation.Processing', e => {
        console.log('event Models.Presentation.Processing', e);
        getData();
      })
      .listen('Models.Presentation.Processed', e => {
        console.log('event Models.Presentation.Processed', e);
        if (store.getters.user && store.getters.user.team_admin) {
          toastr.success(DOMPurify.sanitize(e.message));
        }
        getData();
      })
      .listen('Models.Presentation.ProcessingFailed', e => {
        console.log('event Models.Presentation.ProcessingFailed', e);
        getData();
      })
      .listen('Models.Presentation.RemovedFromFolder', e => {
        console.log('event Models.Presentation.RemovedFromFolder', e);
        getData();
      })
      .listen('Models.Presentation.Updated', e => {
        console.log('event Models.Presentation.Updated', e);
        getData();
      })
      .listen('Models.Presentation.Uploaded', e => {
        console.log('event Models.Presentation.Uploaded', e);
        getData();
      })
      .listen('Models.Presentation.UploadFailed', e => {
        console.log('event Models.Presentation.UploadFailed', e);
        getData();
      })
      .listen('Models.User.AddedToGroup', e => {
        console.log('event Models.User.AddedToGroup', e);
        getData();
      })
      .listen('Models.User.AddedToTeam', e => {
        console.log('event Models.User.AddedToTeam', e);
        getData();
      })
      .listen('Models.User.Created', e => {
        console.log('event Models.User.Created', e);
        getData();
      })
      .listen('Models.User.Deleted', e => {
        console.log('event Models.User.Deleted', e);
        getData();
      })
      .listen('Models.User.Expired', e => {
        console.log('event Models.User.Expired', e);
        getData();
      })
      .listen('Models.User.Locked', e => {
        console.log('event Models.User.Locked', e);
        getData();
      })
      .listen('Models.User.LoggedIntoApp', e => {
        console.log('event Models.User.LoggedIntoApp', e);
        getData();
      })
      .listen('Models.User.LoggedIntoSite', e => {
        console.log('event Models.User.LoggedIntoSite', e);
        getData();
      })
      .listen('Models.User.RemovedFromGroup', e => {
        console.log('event Models.User.RemovedFromGroup', e);
        getData();
      })
      .listen('Models.User.RemovedFromTeam', e => {
        console.log('event Models.User.RemovedFromTeam', e);
        getData();
      })
      .listen('Models.User.SwitchedTeam', e => {
        console.log('event Models.User.SwitchedTeam', e);
        getData();
      })
      .listen('Models.User.Updated', e => {
        console.log('event Models.User.Updated', e);
        getData();
      });

    console.log(`Listening for team events on ${DOMPurify.sanitize(window.ML.user.currentTeam.channel)}`);
  }
}

export default {
  boot() {
    if (window.ML && window.ML.user) {
      listenForCurrentUser();
      listenForCurrentTeam();
    }
    return Promise.resolve();
  }
}
